import * as React from "react";
import { Logs } from "./LogsPage";
import { LogsProvider } from "./context/LogsContext";

type Props = {};

const LogsPage = (props: Props) => {
	return (
		<LogsProvider>
			<Logs />
		</LogsProvider>
	);
};

export default LogsPage;
